document.addEventListener('DOMContentLoaded', changeHeader)

/**
 * ヘッダーの変更
 */
function changeHeader() {
  const headerTransparent = document.querySelector(
    '.global_navigation_bk_transparent_font_white, .global_navigation_bk_transparent_font_black'
  )
  if (!headerTransparent) return

  let color = 'black'
  if (document.querySelector('.global_navigation_bk_transparent_font_white')) {
    color = 'white'
  }

  let target_device = 'sp'
  if (window.innerWidth >= 989) {
    target_device = 'pc'
  }

  const header = document.querySelector('.header-' + target_device)
  const topPage = document.getElementById('top/show') // トップ画面テンプレートのmetaに設定したIDを取得
  const areaPage = document.getElementById('areas/show') // エリア画面テンプレートのmetaに設定したIDを取得
  const catalogLpPage = document.getElementById('catalog-page') // カタログLP画面テンプレートに設定したIDを取得
  const firstView = document.querySelector('.mainvisual, .fv, .mv')
  const isTransparentHeaderTargetPage = [
    topPage,
    areaPage,
    catalogLpPage,
  ].some(Boolean)

  // 対象ページの場合は透過ロゴを表示し、スクロールしたらロゴは消す
  if (isTransparentHeaderTargetPage) {
    // 透過背景用ロゴの初期設定
    initTransparentLogo(target_device)
    updateCatalogLpFvMargin(catalogLpPage, firstView, header)

    // ハンバーガメニューの色を変更
    updateHamburgerMenuColor(color)

    const originalClasses = header ? header.className : ''
    window.addEventListener('scroll', () => {
      handleTopPageScroll(target_device, header, originalClasses, color, firstView)
      updateCatalogLpFvMargin(catalogLpPage, firstView, header)
    })
    // トップ、エリア画面以外の場合
  } else {
    if (target_device == 'pc') {
      // 白背景に黒字のスタイルに変更
      header.classList.remove('global_navigation_bk_transparent_font_black')
      header.classList.remove('global_navigation_bk_transparent_font_white')
      header.classList.add('global_navigation_bk_white_font_black')
    } else {
      // 背景が透過の場合
      const hasSomeClass = [
        'global_navigation_bk_transparent_font_black',
        'global_navigation_bk_transparent_font_white',
      ].some((cls) => header.classList.contains(cls))
      if (hasSomeClass) {
        // FVだけ通常のロゴを表示し、スクロールしたらロゴは消す
        window.addEventListener('scroll', () => handleOtherPageScroll())
      }
    }
  }
}

/**
 * 透過ロゴの初期設定
 */
function initTransparentLogo(target_device) {
  const transparentLogo = document.getElementById('transparent-' + target_device + '_logo')
  if (!transparentLogo) return

  const logo = document.querySelector('.header-' + target_device + '__logo')
  if (logo) logo.style.display = 'none'

  transparentLogo.style.display = 'block'
}

/**
 * TOP画面スクロール時のロゴとヘッダーのクラス変更処理
 */
function handleTopPageScroll(target_device, header, originalClasses, color) {
  const transparentLogo = document.getElementById('transparent-' + target_device + '_logo')
  const normalLogo = document.querySelector('.header-' + target_device + '__logo')
  const globalNav = document.querySelector('.mainvisual, .fv, .mv')
  if (!globalNav || !header) return

  const globalNavPosition = globalNav.getBoundingClientRect().bottom
  const headerHeight = header.offsetHeight

  // ヘッダーがグロナビまで届いた場合
  if (globalNavPosition <= headerHeight) {
    if (target_device === 'sp') {
      if (transparentLogo) transparentLogo.style.visibility = 'hidden'
      updateHamburgerMenuColor('')
    } else {
      // 透過ロゴから通常ロゴを表示
      updateLogoVisibility(normalLogo, transparentLogo, true)

      // 透過クラスを削除して白背景に黒字のクラスを追加
      const removeClasses = [
        'global_navigation_bk_transparent_font_black',
        'global_navigation_bk_transparent_font_white',
      ]
      removeClasses.forEach((removeClass) => {
        if (originalClasses.includes(removeClass)) {
          originalClasses = originalClasses.replace(removeClass, '').trim()
        }
      })
      updateHeaderClass(header, originalClasses + ' global_navigation_bk_white_font_black')
    }
  } else {
    if (target_device === 'sp') {
      if (transparentLogo) transparentLogo.style.visibility = 'unset'
      updateHamburgerMenuColor(color)
    } else {
      updateLogoVisibility(normalLogo, transparentLogo, false)
      updateHeaderClass(header, originalClasses)
    }
  }
}

/**
 * カタログLPのFV表示中はヘッダー重なり用の余白をなくす
 */
function updateCatalogLpFvMargin(catalogLpPage, firstView, header) {
  if (!catalogLpPage || !firstView || !header) return

  const firstViewPosition = firstView.getBoundingClientRect().bottom
  const headerHeight = header.offsetHeight
  const isFirstViewVisible = firstViewPosition > headerHeight

  catalogLpPage.classList.toggle('with-transparent-fv', isFirstViewVisible)
}

/**
 * TOP画面以外のスクロール時ロゴを消してハンバーガーメニューを表示
 */
function handleOtherPageScroll() {
  const normalLogo = document.querySelector('.header-sp__logo')

  if (!normalLogo) return

  // ページの縦のスクロール位置を取得
  const scrollPosition = window.scrollY || window.pageYOffset

  // スクロール位置が少しでもあったら対象要素を非表示
  if (scrollPosition > 0) {
    normalLogo.style.visibility = 'hidden'
  } else {
    normalLogo.style.visibility = 'unset'
  }
}

/**
 * ロゴの表示を切り替える
 */
function updateLogoVisibility(normalLogo, transparentLogo, showNormal) {
  if (normalLogo) normalLogo.style.display = showNormal ? 'block' : 'none'
  if (transparentLogo) transparentLogo.style.display = showNormal ? 'none' : 'block'
}

/**
 * ヘッダーのクラスを変更する
 */
function updateHeaderClass(header, newClass) {
  if (header) {
    header.className = newClass
  }
}

/**
 * ハンバーガーメニューのパスの色を変更する
 */
function updateHamburgerMenuColor(color) {
  const hamburgerMenuPaths = document.getElementById('hamburger_menu').querySelectorAll('path')
  hamburgerMenuPaths.forEach((path) => {
    path.style.stroke = color
  })

  const closeButtonPath = document.querySelector('.header-sp-menu-list__close-button').querySelectorAll('path')

  // 透過背景に白字の場合、黒色に変更
  if (document.querySelector('.global_navigation_bk_transparent_font_white')) {
    color = 'black'
  }

  closeButtonPath.forEach((path) => {
    path.style.stroke = color
  })
}
